import React, { useContext, useState } from 'react'
import { DropdownButton,Dropdown, Row, Col, ButtonGroup } from '@deere/ux.uxframe-react'
import { Button } from "@deere/fuel-react"
import { useOktaAuth } from '@okta/okta-react'
import { getSuppSurveyConfiguration } from '../../services/userService';
import { useTranslation } from "react-i18next";
import i18next from 'i18next'
import cookie from 'js-cookie'
import { handleSaveTpsAnswers} from '../../utils/saveSurveyUtils'
import 'flag-icon-css/css/flag-icons.min.css'
import { getSurveyLanguages } from '../../utils/utils';
import { Context } from  "../../components/tps/TpsContext";
import { getSectionsWithErrors, validatePartsAndSupp, validateDates } from '../../utils/validation';
import { useHistory} from 'react-router';
import {getTPSResponsesByAssignment} from '../../services/tps.service';
import { SCBM_USER_TYPE } from '../../utils/surveyLiterals'
import { useUserInfo } from '../../providers/userProvider'

const ButtonsSection = React.forwardRef(({ campaign, clearFunction, survey, setSurvey, setErrorCard, setSuccessMessage, setTpsResponseSelected, tpsResponseSelected, setIsSubmitted,errorCard, setValidated, sections, tpsForm, setTpsResponses}) => {
    const history = useHistory();
    const { authState } = useOktaAuth();
    const { t } = useTranslation();
    const [currentLanguageCode, setCurrentLanguageCode] = useState(cookie.get('i18next') || 'en');
    const LANGUAGES = getSurveyLanguages(survey.code);
    const {tpsContext} = useContext(Context);
    const suppliers = tpsContext.suppliers
    const parts = tpsContext.parts;
    const answers = tpsContext.answers;
    const userInfo = useUserInfo();
    const [disableSubmit, setDisableSubmit] = useState(userInfo.userType === SCBM_USER_TYPE.SALARY);
    

    const changeLanguage = locale => {
        getSuppSurveyConfiguration(campaign.surveyId, locale, authState.accessToken.accessToken)
                .then((s) => {                
                    setSurvey(s);
        })
        i18next.changeLanguage(locale);
        setCurrentLanguageCode(locale);
    }

    function review(resp){
        history.push({
            pathname: '/tps/review',
            state: {
                previous: '/tps',
                assignmentId: campaign.assignments[0].id,
                response: resp,
                survey: survey
            }
        })
    }

    const handleSubmit = (e) => {
        clearFunction();
        setIsSubmitted(true)
        let errorSections = getSectionsWithErrors(tpsForm);   
        setErrorCard(errorSections);
        validatePartsAndSupp(Array.isArray(suppliers) ? suppliers : [],  Array.isArray(parts) ? parts : [], errorSections, sections, survey.code);      
        setErrorCard(errorSections);

        validateDates(sections, answers, errorSections, tpsForm);
        setErrorCard(errorSections);

        if(errorCard && errorCard.length>0){
            e.preventDefault();
            e.stopPropagation();
        }

        setValidated(true);
        e.preventDefault();
        e.stopPropagation();

        if (tpsForm.checkValidity() && errorSections.length <= 0) {
            setIsSubmitted(false);
            setValidated(false);
            handleSaveTpsAnswers( authState, tpsContext, campaign, tpsResponseSelected?tpsResponseSelected:{id:tpsContext.id}, survey.code).then(resp => {
                if(resp && resp.id){
                    setTpsResponseSelected(resp);
                    review(resp);
                }else{
                    setErrorCard([t('lbl_error_saving_message')]);
                }
    
            }).catch(err=>{
                console.log(err);
                setErrorCard([t('lbl_error_saving_message')]);
            });
            

        }

        window.scrollTo(0, 0); 

    }  



    const handleSave = (e) => {
        if (!tpsContext.responseName || !tpsContext.responseName.trim()) {
          setErrorCard([t("lbl_error_response_name")]);
          setDisableSubmit(false);
          window.scrollTo(0, 0);
        } else {
          setDisableSubmit(true);
          e.preventDefault();
          clearFunction();
          handleSaveTpsAnswers(authState, tpsContext, campaign, tpsResponseSelected ? tpsResponseSelected : { id: tpsContext.id }, survey.code)
            .then((resp) => {
              if (resp && resp.id) {
                getTPSResponsesByAssignment(campaign.assignments[0].id, authState.accessToken.accessToken, survey.code).then((response) => {
                  if (response) {
                    setTpsResponses(response);
                  }
                });
                setTpsResponseSelected(resp);
                setSuccessMessage(t("lbl_success_save_message"));
                setDisableSubmit(false);
                window.scrollTo(0, 0);
              } else {
                setErrorCard([t("lbl_error_saving_message")]);
                setDisableSubmit(false);
                window.scrollTo(0, 0);
              }
            })
            .catch((err) => {
              console.log(err);
              setErrorCard([t("lbl_error_saving_message")]);
              setDisableSubmit(false);
              window.scrollTo(0, 0);
            });
          window.scrollTo(0, 0);
          setDisableSubmit(false);
        }
      };
    
    return (
        <Row className="card position-sticky fixed-bottom">
            <Row className="card position-sticky fixed-bottom">
                <Col md="24" className="card-body p-3 text-right">
                    <ButtonGroup aria-label="Basic example">
                            <DropdownButton variant="secondary" className='mr-2' id="dropdown-basic" title={t('btn_change_language')} onClick={e => e.preventDefault()} >
                                {LANGUAGES.map(({ code, name, country_code }) => (
                                    currentLanguageCode === code ? <Dropdown.Item key={country_code}
                                        href="#" className="nav-link active" onClick={e => e.preventDefault()}>
                                        <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 0.3 }}></span>{name}
                                    </Dropdown.Item> : <Dropdown.Item key={country_code}
                                        href="#" onClick={() => changeLanguage(code)}>
                                        <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 1 }}></span>{name}
                                    </Dropdown.Item>
                                ))}
                            </DropdownButton >
                        <Button className='mr-2' variant="secondary" onClick={handleSave} disabled={disableSubmit}>{t('btn_save_survey')}</Button>
                        <Button className='mr-2' variant="primary" type='submit' onClick={handleSubmit} disabled={disableSubmit}>{t('btn_review')}</Button>
                    </ButtonGroup>
                </Col>
            </Row>
        </Row>
    )
})

export default ButtonsSection
